import { useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { callService } from '@api/remote-call';
import { TourVariationViewModel } from '@api/index';
import { TourType } from '@api/v3';

import { Guest } from '../TourRoomGuest/props';
import {
  getChildrenBirthDates,
  getGuestsCount,
  validateSingleTourRoomChildrenAges,
} from '../TourSelectionCard/helpers';

export const useGetTourVariations = (
  tourId: number,
  packageDetailId: number,
  guest: Guest,
  type: TourType,
  personQuota?: number,
  price3?: number
) => {
  const [tourDetailVariations, setTourDetailVariations] = useState<
    TourVariationViewModel[]
  >([]);
  const [showGuestsWarning, setShowGuestsWarning] = useState<boolean>(false);
  const [showGuestsWarningPrice, setShowGuestsWarningPrice] =
    useState<boolean>(false);

  // ===================================
  //  Handle getting the tour variations
  // ===================================
  const { isError, isSuccess, isLoading } = useQuery(
    ['tour-precalculate', JSON.stringify(guest)],
    () => getDetailVariation(),
    {
      enabled: Boolean(tourId && packageDetailId && guest),
    }
  );

  const getDetailVariation = async () => {
    if (guest.adultNumber > 2 && !price3) {
      setShowGuestsWarning(false);
      return setShowGuestsWarningPrice(true);
    }
    if (getGuestsCount([guest]) > (personQuota || 0)) {
      setShowGuestsWarningPrice(false);
      return setShowGuestsWarning(true);
    }
    setShowGuestsWarningPrice(false);
    setShowGuestsWarning(false);

    const isValidDates = validateSingleTourRoomChildrenAges(guest);

    if (!isValidDates) {
      return;
    }
    try {
      const { detailedVariations } = await callService(
        { service: 'ToursService', method: 'tourPrecalculate', version: 'v3' },
        {
          body: {
            type,
            searchParameters: {
              id: tourId ?? 0,
              packageDetailId: packageDetailId ?? 0,
              guests: [
                {
                  adultCount: guest.adultNumber || 0,
                  childCount: guest.childList?.length || 0,
                  childrenBirthDates: getChildrenBirthDates(guest.childList),
                },
              ],
            },
          },
        }
      );
      if (detailedVariations) {
        setTourDetailVariations([...detailedVariations].reverse());
      } else {
        setTourDetailVariations([]);
      }
    } catch (error) {
      // Log Error
    }
  };

  return {
    tourDetailVariations,
    showGuestsWarning,
    showGuestsWarningPrice,
    isError,
    isSuccess,
    showEmptyVariationGuestsNote:
      tourDetailVariations &&
      tourDetailVariations.length === 0 &&
      !isLoading &&
      !showGuestsWarning &&
      !showGuestsWarningPrice,
  };
};
